import "../../../../../chunks/async.js";
import { j as await_block, f as derived, a as attr, e as ensure_array_like, b as escape_html, c as attr_class } from "../../../../../chunks/renderer.js";
import "../../../../../chunks/servers.remote.js";
import "@sveltejs/kit/internal";
import "../../../../../chunks/url.js";
import "../../../../../chunks/utils.js";
import "@sveltejs/kit/internal/server";
import "../../../../../chunks/root.js";
import "../../../../../chunks/exports.js";
import "../../../../../chunks/state.svelte.js";
import { J as JsonValue_1 } from "../../../../../chunks/JsonValue.js";
import { M as Modal } from "../../../../../chunks/Modal.js";
import { P as Panel } from "../../../../../chunks/Panel.js";
import { S as SvelteSet } from "../../../../../chunks/index-server.js";
function _page($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { data } = $$props;
    const readOnly = derived(() => data.readOnly);
    const usersResult = derived(() => data.users);
    let showCreateModal = false;
    let creatingUser = false;
    let newUsername = "";
    let newPassword = "";
    let newUserDb = "admin";
    let newRole = "read";
    let newRoleDb = "admin";
    let newRoles = [];
    let showDropModal = false;
    let userToDrop = null;
    let droppingUser = false;
    const operatingUsers = new SvelteSet();
    function userKey(u, db) {
      return `${u}@${db}`;
    }
    function closeDropModal() {
      showDropModal = false;
      userToDrop = null;
    }
    let showRolesModal = false;
    let rolesUser = null;
    let currentRoles = [];
    let inheritedPrivileges = null;
    let addRoleName = "read";
    let addRoleDb = "admin";
    let updatingRoles = false;
    function closeRolesModal() {
      showRolesModal = false;
      rolesUser = null;
      currentRoles = [];
      inheritedPrivileges = null;
    }
    let showPasswordModal = false;
    let passwordUser = null;
    let newPasswordValue = "";
    let updatingPassword = false;
    function closePasswordModal() {
      showPasswordModal = false;
      passwordUser = null;
      newPasswordValue = "";
    }
    const availableRoleNames = derived(() => {
      {
        return ["read", "readWrite", "dbAdmin", "userAdmin", "clusterAdmin"].sort();
      }
    });
    const databaseNames = derived(() => {
      {
        return ["admin"];
      }
    });
    function roleLabel(role) {
      if (typeof role === "string") {
        return `${role}@admin`;
      }
      return `${role.role}@${role.db ?? "admin"}`;
    }
    function groupPrivileges(privs) {
      if (!Array.isArray(privs)) {
        return [];
      }
      const byDb = {};
      for (const p of privs) {
        const db = p?.resource?.db ?? "*";
        const coll = p?.resource?.collection ?? "*";
        byDb[db] ??= {};
        byDb[db][coll] ??= {};
        for (const a of p.actions ?? []) {
          byDb[db][coll][a] = true;
        }
      }
      return Object.keys(byDb).sort().map((db) => ({
        db,
        collections: Object.keys(byDb[db]).sort().map((collection) => ({
          collection,
          actions: Object.keys(byDb[db][collection]).sort()
        }))
      }));
    }
    await_block(
      $$renderer2,
      usersResult(),
      () => {
        Panel($$renderer2, {
          title: "Users",
          children: ($$renderer3) => {
            $$renderer3.push(`<div class="loading">Loading users...</div>`);
          },
          $$slots: { default: true }
        });
      },
      (res) => {
        if (res.error) {
          $$renderer2.push("<!--[0-->");
          Panel($$renderer2, {
            title: "Users",
            children: ($$renderer3) => {
              $$renderer3.push(`<div class="p-4"><p class="error">Error loading users: ${escape_html(res.error)}</p> <p class="text-sm mt-2" style="color: var(--text-darker);">User management requires the connected MongoDB user to have the <code>userAdmin</code> or <code>userAdminAnyDatabase</code> role (or equivalent) on the <code>admin</code> database.</p></div>`);
            },
            $$slots: { default: true }
          });
        } else {
          $$renderer2.push("<!--[-1-->");
          $$renderer2.push(`<div class="mb-4 flex gap-3">`);
          if (!readOnly()) {
            $$renderer2.push("<!--[0-->");
            $$renderer2.push(`<button class="btn btn-success btn-sm" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 inline mr-1"><path d="M12 5v14M5 12h14"></path></svg> Create User</button>`);
          } else {
            $$renderer2.push("<!--[-1-->");
          }
          $$renderer2.push(`<!--]--></div> `);
          if (res.data.length === 0) {
            $$renderer2.push("<!--[0-->");
            Panel($$renderer2, {
              title: "Users",
              children: ($$renderer3) => {
                $$renderer3.push(`<div class="text-center p-4" style="color: var(--text-darker)">No users found</div>`);
              },
              $$slots: { default: true }
            });
          } else {
            $$renderer2.push("<!--[-1-->");
            Panel($$renderer2, {
              title: `Users on ${data.server}`,
              children: ($$renderer3) => {
                $$renderer3.push(`<div class="table-wrapper svelte-1sv3xi8"><table class="table svelte-1sv3xi8"><thead><tr><th class="name-column svelte-1sv3xi8">Username</th><th>Database</th><th>Roles</th><th>Privileges</th>`);
                if (!readOnly()) {
                  $$renderer3.push("<!--[0-->");
                  $$renderer3.push(`<th style="width: 280px">Actions</th>`);
                } else {
                  $$renderer3.push("<!--[-1-->");
                }
                $$renderer3.push(`<!--]--></tr></thead><tbody class="svelte-1sv3xi8"><!--[-->`);
                const each_array = ensure_array_like(res.data);
                for (let $$index_4 = 0, $$length = each_array.length; $$index_4 < $$length; $$index_4++) {
                  let user = each_array[$$index_4];
                  const isLoading = operatingUsers.has(userKey(user.user, user.db));
                  $$renderer3.push(`<tr${attr_class("group", void 0, { "opacity-50": isLoading })}><td class="name-cell svelte-1sv3xi8"><span class="font-mono text-sm">${escape_html(user.user)}</span></td><td class="svelte-1sv3xi8"><span class="text-sm">${escape_html(user.db)}</span></td><td class="svelte-1sv3xi8"><div class="flex flex-wrap gap-2">`);
                  if (user.roles && user.roles.length > 0) {
                    $$renderer3.push("<!--[0-->");
                    $$renderer3.push(`<!--[-->`);
                    const each_array_1 = ensure_array_like(user.roles);
                    for (let $$index = 0, $$length2 = each_array_1.length; $$index < $$length2; $$index++) {
                      let role = each_array_1[$$index];
                      $$renderer3.push(`<span class="role-badge svelte-1sv3xi8"${attr("title", `${role.role} on ${role.db}`)}>${escape_html(roleLabel(role))}</span>`);
                    }
                    $$renderer3.push(`<!--]-->`);
                  } else {
                    $$renderer3.push("<!--[-1-->");
                    $$renderer3.push(`<span style="color: var(--text-darker);">No roles</span>`);
                  }
                  $$renderer3.push(`<!--]--></div></td><td class="svelte-1sv3xi8"><details class="cursor-pointer"><summary class="details-link svelte-1sv3xi8">View ${escape_html(user.inheritedPrivileges?.length ?? 0)} privilege
												${escape_html(user.inheritedPrivileges?.length === 1 ? "" : "s")}</summary> <div class="details-content svelte-1sv3xi8">`);
                  if (user.inheritedPrivileges && user.inheritedPrivileges.length > 0) {
                    $$renderer3.push("<!--[0-->");
                    $$renderer3.push(`<div class="privilege-groups svelte-1sv3xi8"><!--[-->`);
                    const each_array_2 = ensure_array_like(groupPrivileges(user.inheritedPrivileges));
                    for (let $$index_3 = 0, $$length2 = each_array_2.length; $$index_3 < $$length2; $$index_3++) {
                      let group = each_array_2[$$index_3];
                      $$renderer3.push(`<div class="priv-group svelte-1sv3xi8"><div class="priv-db svelte-1sv3xi8">${escape_html(group.db)}</div> <div class="priv-colls svelte-1sv3xi8"><!--[-->`);
                      const each_array_3 = ensure_array_like(group.collections);
                      for (let $$index_2 = 0, $$length3 = each_array_3.length; $$index_2 < $$length3; $$index_2++) {
                        let c = each_array_3[$$index_2];
                        $$renderer3.push(`<div class="priv-coll svelte-1sv3xi8"><span class="priv-coll-name svelte-1sv3xi8"${attr("title", c.collection)}>${escape_html(c.collection)}</span> <div class="priv-actions svelte-1sv3xi8"><!--[-->`);
                        const each_array_4 = ensure_array_like(c.actions);
                        for (let $$index_1 = 0, $$length4 = each_array_4.length; $$index_1 < $$length4; $$index_1++) {
                          let action = each_array_4[$$index_1];
                          $$renderer3.push(`<span class="priv-action svelte-1sv3xi8">${escape_html(action)}</span>`);
                        }
                        $$renderer3.push(`<!--]--></div></div>`);
                      }
                      $$renderer3.push(`<!--]--></div></div>`);
                    }
                    $$renderer3.push(`<!--]--></div>`);
                  } else {
                    $$renderer3.push("<!--[-1-->");
                    $$renderer3.push(`<span style="color: var(--text-darker);">No resolved privileges</span>`);
                  }
                  $$renderer3.push(`<!--]--></div></details></td>`);
                  if (!readOnly()) {
                    $$renderer3.push("<!--[0-->");
                    $$renderer3.push(`<td class="svelte-1sv3xi8"><div class="flex gap-1.5 items-center justify-end whitespace-nowrap hidden group-hover:flex"><button class="btn btn-outline-primary px-2 py-1 text-xs whitespace-nowrap"${attr("disabled", isLoading, true)}>Edit Roles</button> <button class="btn btn-outline-light px-2 py-1 text-xs whitespace-nowrap"${attr("disabled", isLoading, true)}>Password</button> <button class="btn btn-outline-danger px-2 py-1 text-xs whitespace-nowrap"${attr("disabled", isLoading, true)}>Drop</button></div></td>`);
                  } else {
                    $$renderer3.push("<!--[-1-->");
                  }
                  $$renderer3.push(`<!--]--></tr>`);
                }
                $$renderer3.push(`<!--]--></tbody></table></div>`);
              },
              $$slots: { default: true }
            });
          }
          $$renderer2.push(`<!--]-->`);
        }
        $$renderer2.push(`<!--]-->`);
      }
    );
    $$renderer2.push(`<!--]--> `);
    {
      let footer = function($$renderer3) {
        $$renderer3.push(`<button class="btn btn-default btn-sm"${attr("disabled", creatingUser, true)}>Cancel</button> <button class="btn btn-success btn-sm"${attr("disabled", !newUsername, true)}>${escape_html("Create User")}</button>`);
      };
      Modal($$renderer2, {
        show: showCreateModal,
        onclose: () => showCreateModal = false,
        title: "Create User",
        wide: true,
        footer,
        children: ($$renderer3) => {
          $$renderer3.push(`<div class="space-y-4"><div><label for="new-username" class="block text-sm font-semibold mb-2" style="color: var(--text);">Username <span style="color: var(--error);">*</span></label> <input id="new-username" type="text"${attr("value", newUsername)} placeholder="username" class="w-full p-2 rounded border border-[var(--border-color)] bg-[var(--color-1)] text-sm focus:outline-none focus:ring-2" style="color: var(--text); --tw-ring-color: var(--link);"/></div> <div><label for="new-password" class="block text-sm font-semibold mb-2" style="color: var(--text);">Password <span style="color: var(--error);">*</span></label> <input id="new-password" type="password"${attr("value", newPassword)} placeholder="password" class="w-full p-2 rounded border border-[var(--border-color)] bg-[var(--color-1)] text-sm focus:outline-none focus:ring-2" style="color: var(--text); --tw-ring-color: var(--link);"/></div> <div><label for="new-user-db" class="block text-sm font-semibold mb-2" style="color: var(--text);">Authentication Database</label> <p class="text-xs mb-2" style="color: var(--text-darker);">The database the user is created on. Usually <code>admin</code>.</p> `);
          $$renderer3.select(
            {
              id: "new-user-db",
              value: newUserDb,
              class: "w-full p-2 rounded border border-[var(--border-color)] bg-[var(--color-1)] text-sm",
              style: "color: var(--text);"
            },
            ($$renderer4) => {
              $$renderer4.push(`<!--[-->`);
              const each_array_5 = ensure_array_like(databaseNames());
              for (let $$index_5 = 0, $$length = each_array_5.length; $$index_5 < $$length; $$index_5++) {
                let db = each_array_5[$$index_5];
                $$renderer4.option({ value: db }, ($$renderer5) => {
                  $$renderer5.push(`${escape_html(db)}`);
                });
              }
              $$renderer4.push(`<!--]-->`);
            }
          );
          $$renderer3.push(`</div> <div><div class="block text-sm font-semibold mb-2" style="color: var(--text);">Roles</div> <p class="text-xs mb-2" style="color: var(--text-darker);">Optionally assign roles now. You can change them later via "Edit Roles".</p> <div class="flex gap-2 items-center">`);
          $$renderer3.select(
            {
              value: newRole,
              class: "p-2 rounded border border-[var(--border-color)] bg-[var(--color-1)] text-sm",
              style: "color: var(--text);"
            },
            ($$renderer4) => {
              $$renderer4.push(`<!--[-->`);
              const each_array_6 = ensure_array_like(availableRoleNames());
              for (let $$index_6 = 0, $$length = each_array_6.length; $$index_6 < $$length; $$index_6++) {
                let name = each_array_6[$$index_6];
                $$renderer4.option({ value: name }, ($$renderer5) => {
                  $$renderer5.push(`${escape_html(name)}`);
                });
              }
              $$renderer4.push(`<!--]-->`);
            }
          );
          $$renderer3.push(` `);
          $$renderer3.select(
            {
              value: newRoleDb,
              class: "p-2 rounded border border-[var(--border-color)] bg-[var(--color-1)] text-sm",
              style: "color: var(--text);"
            },
            ($$renderer4) => {
              $$renderer4.push(`<!--[-->`);
              const each_array_7 = ensure_array_like(databaseNames());
              for (let $$index_7 = 0, $$length = each_array_7.length; $$index_7 < $$length; $$index_7++) {
                let db = each_array_7[$$index_7];
                $$renderer4.option({ value: db }, ($$renderer5) => {
                  $$renderer5.push(`${escape_html(db)}`);
                });
              }
              $$renderer4.push(`<!--]-->`);
            }
          );
          $$renderer3.push(` <button class="btn btn-outline-primary btn-sm" type="button">Add</button></div> `);
          if (newRoles.length > 0) {
            $$renderer3.push("<!--[0-->");
            $$renderer3.push(`<div class="flex flex-wrap gap-2 mt-2"><!--[-->`);
            const each_array_8 = ensure_array_like(newRoles);
            for (let i = 0, $$length = each_array_8.length; i < $$length; i++) {
              let role = each_array_8[i];
              $$renderer3.push(`<span class="role-badge svelte-1sv3xi8">${escape_html(roleLabel(role))} <button type="button" class="role-remove svelte-1sv3xi8" aria-label="Remove role">×</button></span>`);
            }
            $$renderer3.push(`<!--]--></div>`);
          } else {
            $$renderer3.push("<!--[-1-->");
          }
          $$renderer3.push(`<!--]--></div></div>`);
        }
      });
    }
    $$renderer2.push(`<!----> `);
    {
      let footer = function($$renderer3) {
        $$renderer3.push(`<button class="btn btn-default btn-sm"${attr("disabled", droppingUser, true)}>Cancel</button> <button class="btn btn-outline-danger btn-sm"${attr("disabled", droppingUser, true)}>${escape_html("Drop User")}</button>`);
      };
      Modal($$renderer2, {
        show: showDropModal,
        onclose: closeDropModal,
        title: "Drop User",
        footer,
        children: ($$renderer3) => {
          $$renderer3.push(`<p>Are you sure you want to drop the user <strong>${escape_html(userToDrop?.user)}</strong> `);
          if (userToDrop?.db && userToDrop.db !== "admin") {
            $$renderer3.push("<!--[0-->");
            $$renderer3.push(`on <strong>${escape_html(userToDrop.db)}</strong>`);
          } else {
            $$renderer3.push("<!--[-1-->");
          }
          $$renderer3.push(`<!--]-->? This action cannot be undone.</p> <p class="text-sm mt-2" style="color: var(--text-darker);">The user will lose all access to the database. They can be recreated, but their credentials cannot be recovered.</p>`);
        }
      });
    }
    $$renderer2.push(`<!----> `);
    {
      let footer = function($$renderer3) {
        $$renderer3.push(`<button class="btn btn-default btn-sm">Done</button>`);
      };
      Modal($$renderer2, {
        show: showRolesModal,
        onclose: closeRolesModal,
        title: `Edit Roles — ${rolesUser ?? ""}`,
        wide: true,
        footer,
        children: ($$renderer3) => {
          $$renderer3.push(`<div class="space-y-4"><div><div class="block text-sm font-semibold mb-2" style="color: var(--text);">Current Roles</div> `);
          if (currentRoles.length > 0) {
            $$renderer3.push("<!--[0-->");
            $$renderer3.push(`<div class="flex flex-wrap gap-2"><!--[-->`);
            const each_array_9 = ensure_array_like(currentRoles);
            for (let $$index_9 = 0, $$length = each_array_9.length; $$index_9 < $$length; $$index_9++) {
              let role = each_array_9[$$index_9];
              $$renderer3.push(`<span class="role-badge svelte-1sv3xi8">${escape_html(roleLabel(role))} <button type="button" class="role-remove svelte-1sv3xi8"${attr("disabled", updatingRoles, true)} aria-label="Remove role">×</button></span>`);
            }
            $$renderer3.push(`<!--]--></div>`);
          } else {
            $$renderer3.push("<!--[-1-->");
            $$renderer3.push(`<span style="color: var(--text-darker);">No roles assigned</span>`);
          }
          $$renderer3.push(`<!--]--></div> <div><div class="block text-sm font-semibold mb-2" style="color: var(--text);">Grant a role</div> <div class="flex gap-2 items-center">`);
          $$renderer3.select(
            {
              value: addRoleName,
              class: "p-2 rounded border border-[var(--border-color)] bg-[var(--color-1)] text-sm",
              style: "color: var(--text);"
            },
            ($$renderer4) => {
              $$renderer4.push(`<!--[-->`);
              const each_array_10 = ensure_array_like(availableRoleNames());
              for (let $$index_10 = 0, $$length = each_array_10.length; $$index_10 < $$length; $$index_10++) {
                let name = each_array_10[$$index_10];
                $$renderer4.option({ value: name }, ($$renderer5) => {
                  $$renderer5.push(`${escape_html(name)}`);
                });
              }
              $$renderer4.push(`<!--]-->`);
            }
          );
          $$renderer3.push(` `);
          $$renderer3.select(
            {
              value: addRoleDb,
              class: "p-2 rounded border border-[var(--border-color)] bg-[var(--color-1)] text-sm",
              style: "color: var(--text);"
            },
            ($$renderer4) => {
              $$renderer4.push(`<!--[-->`);
              const each_array_11 = ensure_array_like(databaseNames());
              for (let $$index_11 = 0, $$length = each_array_11.length; $$index_11 < $$length; $$index_11++) {
                let db = each_array_11[$$index_11];
                $$renderer4.option({ value: db }, ($$renderer5) => {
                  $$renderer5.push(`${escape_html(db)}`);
                });
              }
              $$renderer4.push(`<!--]-->`);
            }
          );
          $$renderer3.push(` <button class="btn btn-outline-primary btn-sm" type="button"${attr("disabled", updatingRoles, true)}>Grant</button></div></div> `);
          if (inheritedPrivileges) {
            $$renderer3.push("<!--[0-->");
            $$renderer3.push(`<div><div class="block text-sm font-semibold mb-2" style="color: var(--text);">Resolved Privileges</div> <p class="text-xs mb-2" style="color: var(--text-darker);">Effective privileges inherited from all assigned roles.</p> <div class="priv-details svelte-1sv3xi8">`);
            JsonValue_1($$renderer3, {
              value: inheritedPrivileges,
              autoCollapse: true,
              collapsed: true
            });
            $$renderer3.push(`<!----></div></div>`);
          } else {
            $$renderer3.push("<!--[-1-->");
          }
          $$renderer3.push(`<!--]--></div>`);
        }
      });
    }
    $$renderer2.push(`<!----> `);
    {
      let footer = function($$renderer3) {
        $$renderer3.push(`<button class="btn btn-default btn-sm"${attr("disabled", updatingPassword, true)}>Cancel</button> <button class="btn btn-primary btn-sm"${attr("disabled", !newPasswordValue, true)}>${escape_html("Update Password")}</button>`);
      };
      Modal($$renderer2, {
        show: showPasswordModal,
        onclose: closePasswordModal,
        title: `Reset Password — ${passwordUser?.user ?? ""}`,
        footer,
        children: ($$renderer3) => {
          $$renderer3.push(`<div class="space-y-4"><div><label for="new-pwd" class="block text-sm font-semibold mb-2" style="color: var(--text);">New Password <span style="color: var(--error);">*</span></label> <input id="new-pwd" type="password"${attr("value", newPasswordValue)} placeholder="new password" class="w-full p-2 rounded border border-[var(--border-color)] bg-[var(--color-1)] text-sm focus:outline-none focus:ring-2" style="color: var(--text); --tw-ring-color: var(--link);"/></div></div>`);
        }
      });
    }
    $$renderer2.push(`<!---->`);
  });
}
export {
  _page as default
};
